import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TrustBar from './components/TrustBar';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSteps from './components/ProcessSteps';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

const HomePage = () => (
  <main>
    <Navbar />
    <HeroSection />
    <TrustBar />
    <ServicesOverview />
    <AIAnswerBlock />
    <ProcessSteps />
    <WhyChooseUs />
    <ServiceAreas />
    <Testimonials />
    <FAQSection />
    <FinalCTA />
    <Footer />
  </main>
);

export default HomePage;
